<template>
  <div class="leave-wrap">
    <div class="search-wrap">
      <div class="search">
        <div class="btns">
          <!-- 搜索框 -->
          <!-- <van-search class="search-bar"
                      v-model="searchText"
                      placeholder="请输入用户名/姓名"
                      shape="round"
                      @search="onSearch"
                      @clear="onSearch">
          </van-search>-->
          <!-- 筛选按钮 -->
          <div class="select-btn flex-center" @click="showScreen = !showScreen">
            <i class="iconfont">&#xe61d;</i>&nbsp;筛选
          </div>
        </div>
      </div>
      <!-- 筛选组件 -->
      <screen-items v-show="showScreen" :setCondition="setCondition"></screen-items>
      <van-list
        :style="styleSearch"
        class="refreshWrap"
        v-model="isRefresh"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <ul class="leave-list">
          <li class="leave-item clearfix" v-for="item in list" :key="item.LeaveApplicationID">
            <div @click="details(item)">
              <div class="left fl">
                <span v-if="item.Icon===''">{{item.FullName ? showName(item.FullName) : ''}}</span>
                <div class="details-state fl" v-else :style="{background:'url('+ item.Icon+')' + '0/cover'}"></div>
              </div>
              <div class="right">
                <div class="title">
                  <div class="nowrap tit">{{item.FullName}}提交的请假申请</div>
                  <div class="date fr">{{xy.moment(item.CreateByDate).format('YYYY-MM-DD')}}</div>
                </div>
                <div class="type">请假类型：{{item.TeacherLeaveTypeName}}</div>
                <div class="info">
                  <img :src="cardImgUrl" alt />
                  <div class="right-con">
                    <p>
                      <span
                        class="date"
                      >{{xy.moment(item.StartTime).format('YYYY-MM-DD')}}&nbsp;&nbsp;{{!item.IsCycleLeave?xy.moment(item.StartTime).format('HH:mm'):''}}</span>
                    </p>
                    <p>
                      <span
                        class="date"
                      >{{xy.moment(item.EndTime).format('YYYY-MM-DD')}}&nbsp;&nbsp;{{!item.IsCycleLeave?xy.moment(item.EndTime).format('HH:mm'):''}}</span>
                    </p>
                  </div>
                </div>
                <!-- 0待审批，1审批中，2已通过，3已拒绝，4已撤销，5已过期 （40已撤回） -->
                <div
                  class="status"
                  v-if="item.ApplicationStateNew !== -1"
                  :style="{color: (item.ApplicationStateNew === 0 ? '#4196FF' : item.ApplicationStateNew === 1 ? '#E8A022' : item.ApplicationStateNew === 2 ? '#21A83E' : item.ApplicationStateNew === 3 ? '#D83737' : item.ApplicationStateNew === 4 ? '#666666' : item.ApplicationStateNew === 5 ? '#666666' : '')}"
                >{{item.ApplicationStateNameNew}}</div>
              </div>
            </div>
          </li>
        </ul>
      </van-list>
    </div>
    <SingleBottomBtn @clickBtn="createApproval">创建申请</SingleBottomBtn>
  </div>
</template>
<script>
import SingleBottomBtn from "../../components/SingleBottomBtn";
import ScreenItems from "../../components/ScreenItemsTeacher";
const cardImgUrl = require("@/assets/attendance/data_ask.png");
export default {
  name: "StudentLeaveSubApproval",
  components: {
    ScreenItems,
    SingleBottomBtn
  },
  data() {
    return {
      imgUrl: this.xyMApi + '/base',
      cardImgUrl: cardImgUrl,
      showScreen: false,

      searchText: "",
      leaveTypeID: 0,
      timeType: 0,
      applicationState: 99,
      startTime: "",
      endTime: "",

      //list
      pageIndex: 1,
      pageSize: 15,
      totalItems: 0,
      isRefresh: false, // 是否加载中
      finished: false, // 加载是否完成
      list: [],
      styleSearch: {}
    };
  },
  created() {
    this.getList()
  },
  watch: {
    showScreen: {
      deep: true,
      handler: function(newV, oldV) {
        console.log(newV, oldV);
        if (newV) {
          this.styleSearch = { display: "none" };
        } else {
          this.styleSearch = {};
        }
      }
    }
  },
  methods: {
    showName(name) {
      // 纯中文：汉字姓名大于2个字展示最后2个字，小于等于2个字
      if (/^[\u4e00-\u9fa5]+$/g.test(name)) {
        return name.length > 3 || name.length === 3 ? name.slice(-2) : name;
      } else if (/^[A-Za-z]+$/g.test(name)) {
        // 纯英文名只展示两个字母
        return name.slice(0, 2);
      } else {
        // 其他
        return name.slice(0, 2);
      }
    },
    async getList() {
      var params = {
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
        state: this.applicationState,
        leaveType: this.leaveTypeID,
        startTime: this.startTime,
        endTime: this.endTime
      };
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/TeacherLeaveForMobile/GetMyLeavePageList",
        params
      );
      if (res.success) {
        // 加载状态结束
        this.isRefresh = false;
        if (res.data.data) {
          this.totalItems = res.data.totalRecords;
          let _list = res.data.data;
          this.list = this.list.concat(_list);
        } else {
          this.finished = true;
        }
        if (this.list.length >= this.totalItems) {
          this.finished = true;
        }
      }
    },
    onLoad(params = null) {
      this.pageIndex++;
      params = Object.assign({ pageIndex: this.pageIndex }, params);
      this.getList(params);
    },
    //用户名搜索
    onSearch() {
      this.finished = false;
      this.pageIndex = 1;
      this.list = [];
      this.getList();
    },
    // 子组件调用
    setCondition(leaveTypeID, applicationState, startTime, endTime) {
      this.searchText = "";
      this.showScreen = false;
      this.pageIndex = 1;
      this.finished = false;
      this.leaveTypeID = leaveTypeID;
      this.applicationState = applicationState;
      this.startTime = startTime;
      this.endTime = endTime;
      this.list = [];
      this.getList();
    },
    // 创建请假
    createApproval() {
      this.$router.push(`/home/TeacherLeave/TeacherLeaveCreate`);
      this.$store.commit("attendance/setLeaveTeachersNull", {});
      this.$store.state.attendance.creatFlow.ApplicationDescription = "";
      this.$store.state.attendance.creatFlow.EndTime = "";
      this.$store.state.attendance.creatFlow.LeavePictrueList = [];
      this.$store.state.attendance.creatFlow.StartTime = "";
      this.$store.state.attendance.creatFlow.TeacherLeaveTypeID = "";
      this.$store.state.attendance.creatFlow.dayNum = "";
      this.$store.state.attendance.creatFlow.leavetypeMsg = "";
      this.$store.state.attendance.creatFlow.isShow = false;
    },
    // 详情
    details(item) {
      console.log(item);
      this.$router.push({
        name: "TeacherLeaveDetails",
        params: {
          ApprovalFlowID: item.ApprovalFlowID,
          TeacherLeaveApplicationID: item.TeacherLeaveApplicationID,
          isFrom: "myLeave"
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.leave-wrap {
  padding-bottom: 120px;
  .search-wrap {
    .search {
      display: flex;
      background: #fff;
      height: 80px;
      padding: 0 15px;
      .btns {
        flex: 2;
        display: flex;
        color: #505050;
        .search-btn {
          flex: 1;
        }
        .search-bar {
          flex: 4;
        }
        .select-btn {
          flex: 1;
        }
      }
    }
  }
  // list
  .refreshWrap {
    .leave-list {
      padding: 15px;
      .leave-item {
        background: #fff;
        border-radius: 14px;
        box-shadow: 0px 2px 21px 0px rgba(197, 197, 197, 0.5);
        margin-bottom: 16px;
        padding: 12px 31px 22px 19px;
        .left {
          width: 64px;
          span {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 64px;
            height: 64px;
            text-align: left;
            border-radius: 50%;
            background: @blue;
            font-size: 22px;
            color: #fff;
          }
          .details-state {
            width: 64px;
            height: 64px;
            background: #2980fe;
            border-radius: 50%;
            text-align: center;
            line-height: 92px;
            // margin-top: 40px;
            // margin-left: 70px;
            color: #fff;
            font-size: 30px;
            background-size: 92px 92px;
          }
        }
        .right {
          padding-left: 87px;
          .title {
            display: flex;
            justify-content: space-between;
            .tit {
              flex: 1;
              max-width: 60%;
              font-size: 30px;
              line-height: 64px;
              font-weight: bold;
              color: #333;
            }
            .date {
              line-height: 64px;
              color: #b4b4b4;
              font-size: 24px;
            }
          }
          .type {
            font-size: 24px;
            color: #999;
            width: fit-content;
            height: 36px;
            line-height: 36px;
            padding: 0 20px 0 11px;
            background: rgba(249, 249, 249, 1);
            border-radius: 14px 0px 14px 0px;
          }
          //请假周期时间
          .info {
            margin-top: 15px;
            display: flex;
            color: #666;
            img {
              width: 13px;
              height: 73px;
              margin-top: 10px;
              margin-right: 10px;
            }
            .right-con {
              font-size: 26px;
              .date {
                margin-right: 10px;
                font-size: 28px;
              }
              p:first-child {
                margin-top: 2px;
              }
              p:last-child {
                margin-top: 31px;
              }
            }
          }
          //状态
          .status {
            font-size: 28px;
            margin: 17px 0 0;
            color: #666;
          }
        }
      }
    }
  }
}
</style>
